import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ApplicationNotificationSeverity } from "abweb/service/notification/ApplicationNotificationSeverity";
import { action, makeObservable, observable } from "mobx";

/**
 * Toast
 */
export let ApplicationNotification = (_dec = action.bound, _class = class ApplicationNotification {
  /**
   * Constructs this ApplicationNotification
   *
   * @param message     The text of the notification
   * @param severity    The severity/importance of the notification.  Default: <code>ApplicationNotificationSeverity.WARNING</code>
   * @param detailHandler     The click handler function.  Default: none
   * @param id      optional ID of the notification
   * @param customRenderer     Callback returning arbitrary React content.  Default: none
   * @param detailColumnRenderer     Callback returning React content for details column.  Default: none
   * @param previewRenderer Callback returning React Content for previews
   * @param seen Boolean for whether the notification has been seen or not
   * @param previewText Optional string if there is preview text, for example if there is an embedded comment, this would be an internationalized string "Show Comment"
   */
  constructor(message, severity, detailHandler, customRenderer, id, detailColumnRenderer, /*React.ReactNode*/
  previewRenderer, /*React.ReactNode*/
  seen = false, previewText, deleteCallback, objectRenderer) {
    /**
     * When the notification was created
     */
    _defineProperty(this, "_timestamp", void 0);
    /**
     * The severity/importance of the notification
     */
    _defineProperty(this, "_severity", void 0);
    /**
     * The text of the notification
     */
    _defineProperty(this, "_message", void 0);
    _defineProperty(this, "_id", void 0);
    /**
     * Optional callback that produces arbitrary React content.
     */
    _defineProperty(this, "_customRenderer", void 0);
    /**
     * Optional function to call when the user clicks the notification
     */
    _defineProperty(this, "_detailHandler", void 0);
    /**
     * Optional function to render the details column other than the default link
     */
    _defineProperty(this, "_detailColumnRenderer", void 0);
    /**
     * Optional function to render the preview of the notification
     */
    _defineProperty(this, "_previewRenderer", void 0);
    /**
     * Optional string if there is preview text, for example if there is an embedded comment, this would be an internationalized string "Show Comment"
     */
    _defineProperty(this, "_previewText", void 0);
    /**
     * Optional function callback when deleting a notification
     */
    _defineProperty(this, "_deleteCallback", void 0);
    _defineProperty(this, "_objectRenderer", void 0);
    /**
     * Optional boolean to determine whether notification has been seen before
     */
    _initializerDefineProperty(this, "seen", _descriptor, this);
    this._timestamp = new Date();
    if (severity === undefined) {
      severity = ApplicationNotificationSeverity.WARNING;
    }
    makeObservable(this);
    this._severity = severity;
    this._message = message;
    this._detailHandler = detailHandler;
    this._detailColumnRenderer = detailColumnRenderer;
    this._customRenderer = customRenderer;
    this._id = id;
    this._previewRenderer = previewRenderer;
    this.seen = seen;
    this._previewText = previewText;
    this._deleteCallback = deleteCallback;
    this._objectRenderer = objectRenderer;
  }
  get requiresAttention() {
    return true;
  }
  markAsSeen() {
    this.seen = true;
  }

  /**
   * When the notification was created
   */
  get timestamp() {
    return this._timestamp;
  }

  /**
   * The severity/importance of the notification
   */
  get severity() {
    return this._severity;
  }

  /**
   * The text of the notification
   */
  get message() {
    return this._message;
  }

  /**
   * Optional function to call when the user clicks the notification
   */
  get detailHandler() {
    return this._detailHandler;
  }

  /**
   * Optional function to render a details column other than the default link
   */
  get detailColumnRenderer() {
    return this._detailColumnRenderer;
  }

  /**
   * Optional callback that produces arbitrary React content.
   */
  get customRenderer() {
    return this._customRenderer;
  }
  set customRenderer(val) {
    this._customRenderer = val;
  }
  get previewRenderer() {
    return this._previewRenderer;
  }
  get deleteCallback() {
    return this._deleteCallback;
  }
  get objectRenderer() {
    return this._objectRenderer;
  }
  get previewText() {
    return this._previewText;
  }
  get id() {
    return this._id;
  }
  toString() {
    return `${this._severity}: ${this._message}`;
  }

  /**
   * Compares two Notifications such that the more important one is greater than the less important one.
   * If they have the same importance, then the later message is greater.
   *
   * @param a   notification 1
   * @param b   notification 2
   * @return    a standard comparison value
   */
  static compare(a, b) {
    const cmp = ApplicationNotificationSeverity.compare(a.severity, b.severity);
    if (cmp !== 0) {
      return cmp;
    }
    return a.timestamp.getTime() - b.timestamp.getTime();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "seen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "markAsSeen", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "markAsSeen"), _class.prototype), _class);
//# sourceMappingURL=ApplicationNotification.js.map
